export default __webpack_public_path__ + "static/media/MadMenOfBombay.86614c6f.png";